import React from "react";
import styles from "./Tabs.module.css";

interface TabSpec<T extends string> {
  key: T;
  label: string;
  icon?: React.ReactNode;
}

interface TabsProps<T extends string> {
  tabs: TabSpec<T>[];
  active: T;
  onChange: (next: T) => void;
  /** Optional leading element (e.g. a back button) inserted before the tabs. */
  leading?: React.ReactNode;
}

export default function Tabs<T extends string>({ tabs, active, onChange, leading }: TabsProps<T>) {
  return (
    <div className={styles.tabs}>
      {leading && (
        <>
          <div className={styles.leadingSlot}>{leading}</div>
          <div className={styles.leadingDivider} />
        </>
      )}
      {tabs.map((tab) => {
        const isActive = tab.key === active;
        return (
          <button
            key={tab.key}
            className={`${styles.tab} ${isActive ? styles.tabActive : ""}`}
            onClick={() => onChange(tab.key)}
            type="button"
          >
            {tab.icon && <span className={styles.tabIcon}>{tab.icon}</span>}
            <span>{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}
